import { render, staticRenderFns } from "./ProductRecordList.vue?vue&type=template&id=623827e0&scoped=true&"
import script from "./ProductRecordList.vue?vue&type=script&lang=js&"
export * from "./ProductRecordList.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecordList.vue?vue&type=style&index=0&id=623827e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623827e0",
  null
  
)

export default component.exports